import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay, ease }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] flex items-center gap-3 ${light ? "text-[#E2C9A6]" : "text-[#9A4930]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#E2C9A6]" : "bg-[#9A4930]"}`} />
    {children}
  </p>
);
